export function paperOrderStatus(status) {
  return ({
    SUBMITTING: 'Order confirmed; Alpaca submission is being checked',
    UNKNOWN: 'Alpaca outcome uncertain — do not submit again',
    OPEN: 'Alpaca accepted the order; it has not filled',
    PARTIALLY_FILLED: 'Paper order is partly filled',
    CANCEL_REQUESTED: 'Cancellation requested; a fill may still occur',
    FILLED: 'Paper order filled',
    CANCELED: 'Paper order canceled',
    EXPIRED: 'Paper order expired',
    REJECTED: 'Alpaca rejected this Paper order',
    ABANDONED: 'Order review closed without submission',
  })[status] || 'Checking Paper order';
}

export function paperOrderNextAction(status) {
  return ({
    SUBMITTING: 'Refresh this order’s status. Do not place another order while Pinngro checks the original reference.',
    UNKNOWN: 'Refresh this order’s status. Do not place another order while Pinngro checks the original reference.',
    OPEN: 'Refresh for fills, or request cancellation. An accepted order is not a completed trade.',
    PARTIALLY_FILLED: 'The remaining quantity may still fill. Refresh status or request cancellation; review holdings before another trade.',
    CANCEL_REQUESTED: 'Cancellation is not final. Refresh status; a fill may still occur.',
    FILLED: 'Refresh Portfolio to see broker-confirmed holdings, buying power and order history.',
    CANCELED: 'Review the filled quantity and refresh Portfolio; cancellation may follow a partial fill.',
    REJECTED: 'Review the broker result before preparing a different order.',
    EXPIRED: 'Review the filled quantity and refresh Portfolio before preparing another order.',
    ABANDONED: 'No broker order was submitted from this review. Start a new review if you still want to trade.',
  })[status] || 'Refresh this order’s status before taking another action.';
}

export function paperAccountLabel(accountId) {
  return accountId ? `Alpaca Paper account ending ${String(accountId).slice(-4).toUpperCase()}` : 'Alpaca Paper account';
}

export function paperOrderProblem(error) {
  const reason = error?.response?.data?.detail?.reason;
  return ({
    paper_trading_consent_required: 'Your Alpaca Paper connection needs trading permission.',
    paper_submission_disabled: 'Manual Alpaca Paper orders are awaiting activation. Your portfolio remains available to view.',
    paper_beta_not_eligible: 'Manual Paper trading is currently available only to eligible Pinngro beta accounts.',
    paper_account_not_activated: 'This Alpaca Paper account is not activated for manual trading, or its access has expired. Your portfolio remains available to view.',
    oauth_not_connected: 'Connect an Alpaca Paper account before trading.',
    oauth_authorization_failed: 'Alpaca authorization is unavailable. Reconnect your Paper account.',
    oauth_connection_changed: 'The connected Paper account changed. Review the order again.',
    insufficient_buying_power: 'The Paper account does not have enough available buying power for this order.',
    insufficient_shares: 'The Paper account does not have enough uncommitted shares to sell.',
    current_quote_unavailable: 'A fresh Alpaca Paper quote is unavailable. Keep your order details and try Review again during regular market hours.',
    asset_not_eligible: 'Alpaca does not currently allow this stock to be traded in this Paper account.',
    provider_rate_limited: 'Alpaca is temporarily limiting requests. Try again later.',
    provider_outcome_unknown: 'The broker outcome is uncertain. Refresh this order’s status; do not submit another order.',
    provider_unavailable: 'Alpaca is unavailable. Keep your order details and try again later.',
    order_invalid: 'Check the stock, action, order type and time in force, then review again.',
    amount_invalid: 'Enter a positive amount with the supported number of decimal places, then review again.',
    quantity_or_notional_required: 'Enter either a share quantity or a dollar amount, then review again.',
    notional_combination_unsupported: 'Dollar amounts are supported only for a Day market Buy. Choose shares for this order.',
    fractional_order_requires_day: 'Fractional shares require a Day order. Change the time in force and review again.',
    idempotency_conflict: 'This review key already belongs to a different order. Edit and review again.',
    broker_order_not_yet_confirmed: 'Alpaca has not confirmed an order to cancel yet. Refresh its status.',
  })[reason] || 'The Paper order could not be checked. Keep this order open and check its status before trying another action.';
}
